import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "api/admin";
import { ONBOARDING_IMAGES_QUERY_KEY } from "./useOnboardingImages";

const useSaveOnboardingImages = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (images: string[]) => {
      await adminApiClient.saveOnboardingImages(images);
      return images;
    },
    onSuccess: (images) => {
      queryClient.setQueryData([ONBOARDING_IMAGES_QUERY_KEY], { images });
    },
  });
};

export default useSaveOnboardingImages;
